module.exports = __webpack_public_path__ + "assets/company.aa1beba8.svg";